module.exports = __webpack_public_path__ + "img/logo-main.aabefe1.png";